import React, { useState, useEffect } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'
import { useWindowSize } from "@uidotdev/usehooks";
import { hasPermissions } from '../Utils/groups'
import Painel from './Liberacao/painel'
import NovoPedido from './Order'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PostAddSharpIcon from '@mui/icons-material/PostAddSharp';



const MenuList = () => {

    return ({
        'painel': {
            title: 'Liberação',
            icon: (<ReceiptLongIcon />),
            obj: (<Painel />),
            permission: (hasPermissions('administrador', 'admfilial', 'representante', 'funcRepresentante', 'LiberacoesPedido', 'grupo_administradores', 'ccc'))
        },
        'novopedido': {
            title: 'Pedidos',
            icon: (<PostAddSharpIcon />),
            obj: (<NovoPedido />),
            permission: (hasPermissions('administrador', 'grupo_administradores', 'admfilial', 'representante', 'funcRepresentante'))
        }
    })
}

const CalcWidthSize = (size) => {
    const threshold = size?.width < 768 ? 200 : 400
    const calcSize = Math.round(size?.width / threshold)
    if (!calcSize)
        return 2
    return calcSize
}

const Cadastros = () => {

    const [selectedTab, setSelectedTab] = useState()
    const size = useWindowSize();

    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(() => {
        window.backtobase = () => setSelectedTab()
    }, [])

    return (
        <>
            {!selectedTab ?
                <>
                    <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                        {itens.map(([key, value]) => (
                            <ColorButton
                                onClick={() => setSelectedTab(key)}
                                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                fColor={apptheme.primaryColor}
                                sColor={apptheme.tertiaryColor}>
                                <Box className='flexbox'>
                                    {value.icon}
                                    {value.title}
                                </Box>
                            </ColorButton>

                        ))}
                    </Box>
                </>
                :
                <>
                    {MenuList()[selectedTab].obj}
                </>
            }

        </>
    )
}

export default Cadastros;